// src/components/ApproveUSDT.js
import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { USDT_ADDRESS, CONTRACT_ADDRESS } from "../utils";
import Modal from "./Modal";

export default function ApproveUSDT({ wallet, levelInvestments }) {
  const [loading, setLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const [allowance, setAllowance] = useState("0");
  const [alertModal, setAlertModal] = useState({ show: false, title: "", message: "" });

  const showAlert = (title, message) => {
    setAlertModal({ show: true, title, message });
  };

  const fetchAllowance = async () => {
    try {
      const usdtContract = new ethers.Contract(
        USDT_ADDRESS,
        ["function allowance(address owner, address spender) view returns (uint256)"],
        wallet.provider
      );

      const raw = await usdtContract.allowance(wallet.address, CONTRACT_ADDRESS);
      const formatted = ethers.formatUnits(raw, 18);
      setAllowance(formatted);

      if (parseFloat(formatted) >= levelInvestments[7]) {
        setApproved(true);
      }
    } catch (err) {
      console.error("Error fetching allowance:", err);
    }
  };

  const handleApprove = async () => {
    try {
      setLoading(true);

      const usdtContract = new ethers.Contract(
        USDT_ADDRESS,
        ["function approve(address spender, uint256 amount) public returns (bool)"],
        wallet.signer
      );

      const maxAmount = ethers.parseUnits(levelInvestments[7].toString(), 18);

      const tx = await usdtContract.approve(CONTRACT_ADDRESS, maxAmount);
      await tx.wait();

      showAlert("Success", "Approval successful! You can now create or join pools.");
      await fetchAllowance();
    } catch (err) {
      console.error("Approval error:", err);
      showAlert("Error", "Approval failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (wallet?.address && wallet?.provider) {
      fetchAllowance();
      const interval = setInterval(fetchAllowance, 10000);
      return () => clearInterval(interval);
    }
  }, [wallet]);

  return (
    <div className="approve-box">
    <div className="bg-yellow-100 border border-yellow-300 rounded">
      <p className="text-sm text-gray-700 font-medium">
        Approve USDT before joining or creating pools.
      </p>
      <p className="text-sm text-gray-800 mb-3">
        <strong>Current Allowance:</strong> {allowance} USDT
      </p>
      <button
        onClick={handleApprove}
        disabled={loading || approved}
        className={`approve-btn ${approved ? "btn-approved" : loading ? "btn-disabled" : "btn-primary"}`}
      >
        {approved ? "✅ USDT Approved" : loading ? "⏳ Approving..." : "💳 Approve USDT"}
      </button>

      {alertModal.show && (
        <Modal
          isOpen={alertModal.show}
          onClose={() => setAlertModal({ show: false, title: "", message: "" })}
        >
          <div className="p-4">
            <h3 className="font-bold text-xl mb-2">{alertModal.title}</h3>
            <p className="mb-4 whitespace-pre-wrap">{alertModal.message}</p>
          </div>
        </Modal>
      )}
    </div>
    </div>
  );
}